import React, { useCallback } from "react";
import { Col, Row } from "react-bootstrap";

import { Skeleton } from "components";
import { FundingTypes } from "types";
import { floatWithComma2Normalizer } from "validators";

import { ReactComponent as Checked } from "static/images/checked.svg";
import styles from "./merchantInfo.module.scss";

const DecisionView = ({ decisionData, loading }) => {
	const PriceFieldWithLoaderTable = useCallback(
		({ label, firstPrice, secondPrice }) => {
			const pricesBlock = loading ? (
				<td>
					{" "}
					<Skeleton
						height="24px"
						width="100%"
						marginBottom="16px"
						marginLeft="20px"
						variant="text"
					/>
				</td>
			) : (
				<>
					<th className={styles.price}>
						{floatWithComma2Normalizer(firstPrice, "$")}
					</th>

					<th className={styles.price}>
						{floatWithComma2Normalizer(secondPrice, "$")}
					</th>
				</>
			);

			return (
				<tr className={styles.childPrice}>
					<th className={styles.priceTitle}>{label}</th>
					{pricesBlock}
				</tr>
			);
		},
		[loading],
	);

	const FundingTypesWithLoader = useCallback(() => {
		if (loading) {
			return (
				<div>
					<p className={styles.title}>Funding Types</p>
					<Skeleton height="24px" width="100%" variant="text" />
				</div>
			);
		} else {
			return (
				<div>
					<h3 className={styles.title}>Funding Types</h3>
					<p className={styles.desc}>
						{FundingTypes.getDisplayName(decisionData?.fundingType)}
						{decisionData?.isDailyDiscount && (
							<>
								<Checked className={styles.iconChecked} /> Daily
								Discount
							</>
						)}
					</p>
				</div>
			);
		}
	}, [loading, decisionData]);

	return (
		<div className={styles.wrappDecission}>
			<Row>
				<Col lg={6}>
					<table className={styles.tablePricesMerchantinfo}>
						<thead>
							<tr>
								<th className={styles.priceTitle}></th>
								<th className={styles.priceTitle}>V/MC/D</th>
								<th className={styles.priceTitle}>Amex</th>
							</tr>
						</thead>
						<tbody>
							<PriceFieldWithLoaderTable
								label="Monthly Volume"
								firstPrice={decisionData?.visaMcDiscover_AMV}
								secondPrice={decisionData?.amex_AMV}
							/>
							<PriceFieldWithLoaderTable
								label="Avg Ticket"
								firstPrice={decisionData?.visaMcDiscover_AVT}
								secondPrice={decisionData?.amex_AVT}
							/>
							<PriceFieldWithLoaderTable
								label="High Ticket"
								firstPrice={decisionData?.visaMcDiscover_HT}
								secondPrice={decisionData?.amex_HT}
							/>
						</tbody>
					</table>
				</Col>
			</Row>
			<div className={styles.wrappFundingContent}>
				<FundingTypesWithLoader />
			</div>
		</div>
	);
};

export default DecisionView;
